import { render, staticRenderFns } from "./NuevoConcurso.vue?vue&type=template&id=08562761&scoped=true&"
import script from "./NuevoConcurso.vue?vue&type=script&lang=js&"
export * from "./NuevoConcurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08562761",
  null
  
)

export default component.exports